import { Spinner } from "@digipost/dds-spinner-react";
import { type FC, useEffect, useRef } from "react";
import { useSelector } from "react-redux";

import { type User } from "../../../../types/session";
import { type ReduxState } from "../redux/state";
import { useRootPath } from "../useRootPath";
import styles from "./RedirectToCorrectForm.module.css";

const isAuthenticatedWithIdPorten = (user: Partial<User>): boolean =>
  user.authLevelIDPorten === "IDPORTEN_3" ||
  user.authLevelIDPorten === "IDPORTEN_4";

export const RedirectToCorrectForm: FC = () => {
  const userInfo = useSelector((state: ReduxState) => state.user.info);
  const hasExecuted = useRef(false);
  const rootPath = useRootPath();

  useEffect(() => {
    if (userInfo !== undefined && !hasExecuted.current) {
      hasExecuted.current = true;

      if (isAuthenticatedWithIdPorten(userInfo)) {
        window.location.href = `${rootPath}/person`;
      } else {
        window.location.href = `${rootPath}/bedrift`;
      }
    }
  }, [userInfo]);

  return (
    <div className={styles.spinnerContainer}>
      <Spinner size="large" />
    </div>
  );
};
